import { Route, Routes } from 'react-router-dom'
import Home from './index'
import HomePage from './pages/HomePage'
import EmailSignIn from './pages/EmailSignIn'
import EmailVerification from './pages/EmailVerification'

export const homeRoutes = {
  subdomain: 'www',
  main: true,
  routes: () => (
    <Routes>
      <Route path='/' element={<Home />}>
        <Route path='' element={<HomePage />} />
        {/* <Route path='email-sign-in' element={<EmailSignIn />} />
        <Route path='email-verification' element={<EmailVerification />} /> */}
      </Route>
    </Routes>
  ),
}
